export const createRange = (start: number, end: number): number[] => {
  return Array.from({ length: end - start + 1 }, (_, index) => start + index)
}

export const parseAwsTokenToObject = (token: string) => {
  const spitedToken = token?.split(".")
  if (spitedToken?.length === 3) {
    const token = {
      awsAccessKey: spitedToken[0],
      awsJwtToken: spitedToken[1],
      awsSecretAccessKey: spitedToken[2],
    }
    return token
  }
  return undefined
}
